import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../Interceptor/interceptor";


export const stateApi = createApi({
    reducerPath: 'stateApi',
    baseQuery: baseApiQuery,
    tagTypes: ["posts"],
    endpoints: (builder) => ({
        getState: builder.query({
            query: () => ({
                url: 'states/1/list/', // 1 represents the country id for India
                method: "GET",
            }),
            providesTags: ['posts']
        }),
    })
})

export const { useGetStateQuery } = stateApi